import { Component, inject, Input, OnInit } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { MainService } from 'BaseServices/main-service';
import { UserService } from 'BaseServices/user-service';
import {
  ClientSummaryDTO,
  ComponentGroupDTO,
  ComponentGroupTranslation,
  ComponentDetailDTO,
  ComponentSummaryDTO,
  PlantSummaryDTO,
} from 'projects/Assets/src/assets-base/dataTypes';
import {
  dialogData,
  genericDialogComponent,
} from 'projects/Assets/src/assets-base/Dialogs/genericDialog';
import { DeleteButtonComponent } from 'src/app/buttons/delete-button/delete-button.component';
import { SaveButtonComponent } from 'src/app/buttons/save-button/save-button.component';
import { dialogInputTitleComponent } from 'src/app/elements/dialog-input-title.component';

@Component({
  selector: 'app-component-dialog',
  imports: [
    dialogInputTitleComponent,
    FormsModule,
    SaveButtonComponent,
    DeleteButtonComponent,
  ],
  templateUrl: './component-dialog.component.html',
  styleUrls: [
    './component-dialog.component.css',
    '../../../../../../src/app/general-styles/dialogs.css',
  ],
})
export class ComponentDialogComponent
  extends genericDialogComponent
  implements OnInit
{
  readonly data = inject<dialogData<ComponentDetailDTO[]>>(MAT_DIALOG_DATA);
  @Input() componentRequest!: ComponentDetailDTO;

  groupEnum = Object.keys(ComponentGroupDTO)
    .filter((key) => isNaN(Number(key))) // Only string (enum member) keys
    .map((name) => ({
      name: ComponentGroupTranslation[name as keyof typeof ComponentGroupDTO],
      value: name,
    }));
  currentUser = this.userService.currentUser;

  clients: ClientSummaryDTO[] = [];
  plants: PlantSummaryDTO[] = [];

  get shownPlants() {
    return this.plants.filter((p) => {
      if (!this.componentRequest.clientId || this.componentRequest.clientId == 0) return true;
      const client = this.clients.find((c) => c.id === this.componentRequest.clientId);
      if (!client) return false;
      return p.clientName === client.name;
    });
  }
  clientCascade(clientId: number) {
    this.componentRequest.clientId = clientId;
    this.componentRequest.plantId = null;
  }
  
  constructor(
    public override dialogRef: MatDialogRef<ComponentDialogComponent>,
    public mainService: MainService,
    public userService: UserService
  ) {
    super(dialogRef);
    this.componentRequest = this.data.data[0];
    if (this.componentRequest.plantId == undefined)
      this.componentRequest.plantId = null;
  }

  ngOnInit(): void {
    this.mainService.getAll<ClientSummaryDTO>('Client').subscribe((result) => {
      this.clients = result;
    });

    this.mainService.getAll<PlantSummaryDTO>('Plant').subscribe((result) => {
      this.plants = result;
    });
  }
  saveChanges() {
    if (this.componentRequest.id == 0) {
      this.mainService
        .add<ComponentDetailDTO, ComponentSummaryDTO>(
          'Component',
          this.componentRequest
        )
        .subscribe((result) => {
          this.dialogRef.close(true);
        });
    } else {
      this.mainService
        .update<ComponentDetailDTO, ComponentSummaryDTO>(
          'Component',
          this.componentRequest
        )
        .subscribe((result) => {
          this.dialogRef.close(true);
        });
    }
  }

  deleteEntry() {
    if (!confirm("Er du sikker på at du vil slette komponentet?'")) {
      return;
    }
    this.mainService
      .delete('Component', this.componentRequest.id)
      .subscribe((result) => {
        this.dialogRef.close(true);
      });
  }
}
